import { nanoid } from 'nanoid';

/** @type {QueryExecJSONInput['query']} */
const query = {
	select: [
		{
			inherits_extended: -1,
			kid: 'K_NODE;KSYSQUERY',
			id: nanoid(),
			kdata: {
				label: null,
				format: null,
				where: null,
			},
			name: 'Knitiv Requete',
			node: 'REPRE',
			op: 'detail',
			type: 'K_NODE;STRING',
			width: 180,
		},
	],
	from: [
		{
			inherits_extended: -1,
			name: 'Knitiv Requete',
			node: 'K_NODE;KSYSQUERY',
			type: 'K_NODE;STRING',
		},
	],
	where: {
		condition: 'AND',
		rules: [],
	},
	date: '_NOW_',
};

export default query;
